export default __webpack_public_path__ + "static/media/grandma5M.2340b97e.jpg";